<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useRouterTab } from './useRouterTab';

const route = useRoute();
const { cachedViews, getCacheKey, getTabView } = useRouterTab();

const cacheKey = computed(() => getCacheKey(route));
</script>

<template>
  <div
    class="router-tab__container flex-grow-1 overflow-auto h-100 position-relative"
  >
    <router-view v-slot="{ Component }">
      <keep-alive :include="cachedViews">
        <component :is="getTabView(cacheKey)" :key="cacheKey">
          <component :is="Component" />
        </component>
      </keep-alive>
    </router-view>
    <ItpIframeKeepAliveHost />
  </div>
</template>
